/* eslint-disable */
import $ from 'jquery';
/* eslint-enable */

export default function () {
  /* Bootstrap popovers */
  $('[data-toggle="popover"]').popover();
}
